module.exports = __webpack_public_path__ + "img/LI107356.64078b43.png";